export default ({ IDL }) => {
  return IDL.Service({
    'ClearAll' : IDL.Func([], [], []),
    'ImakeAChange' : IDL.Func([IDL.Nat32], [], []),
    'addPlayer' : IDL.Func([IDL.Text], [IDL.Bool], []),
    'isThereAChange' : IDL.Func(
        [],
        [IDL.Vec(IDL.Tuple(IDL.Bool, IDL.Nat32))],
        ['query'],
      ),
    'numberPlayer' : IDL.Func([], [IDL.Bool], ['query']),
    'player1' : IDL.Func([], [IDL.Text], ['query']),
    'player2' : IDL.Func([], [IDL.Text], ['query']),
    'seePlayers' : IDL.Func([], [IDL.Vec(IDL.Text)], ['query']),
    'stateOfGame' : IDL.Func([], [IDL.Bool], ['query']),
    'userLeave' : IDL.Func([], [], []),
    'userLeaved' : IDL.Func([], [IDL.Bool], ['query']),
  });
};
export const init = ({ IDL }) => { return []; };